import { render } from "./ItemSalesDetailReport.vue?vue&type=template&id=20accd30&scoped=true"
import script from "./ItemSalesDetailReport.vue?vue&type=script&lang=js"
export * from "./ItemSalesDetailReport.vue?vue&type=script&lang=js"

import "./ItemSalesDetailReport.vue?vue&type=style&index=0&id=20accd30&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20accd30"]])

export default __exports__